import React from 'react';
import { SvgIcon } from '@material-ui/core'

const EConsulta = (props) => (
  <SvgIcon
    viewBox="0 0 40 26.671"
    {...props}
  >
  <path id="video-light" d="M37.777,66.223a2.224,2.224,0,0,0-1.264.4l-7.619,4.855V67.32A3.468,3.468,0,0,0,25.3,64H3.6A3.468,3.468,0,0,0,0,67.32V87.351a3.468,3.468,0,0,0,3.6,3.32H25.3a3.468,3.468,0,0,0,3.6-3.32V83.2l7.612,4.855A2.227,2.227,0,0,0,40,86.261V68.41a2.2,2.2,0,0,0-2.223-2.188ZM26.671,87.351a1.277,1.277,0,0,1-1.375,1.1H3.6a1.277,1.277,0,0,1-1.375-1.1V67.32a1.277,1.277,0,0,1,1.375-1.1H25.3a1.277,1.277,0,0,1,1.375,1.1Zm11.113-1.09-.083-.09-8.807-5.612V74.106l8.89-5.661Z" transform="translate(0 -64)" fill="#707070"/>
  </SvgIcon>
);

export default EConsulta;